module.exports = "https://99designs-start-assets.imgix.net/js/c3e345b8e53ccbd21917fd0568dd1b1b.png";